export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    height="20"
    width="20"
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    >
      <path d="M1 5h30v22H1zM13 20v-8" strokeWidth="2" />
      <path
        d="M5 12v2.72A9.98 9.98 0 007 20a9.98 9.98 0 002-5.28V12M19.2 12h-1.6a1.6 1.6 0 00-1.6 1.6c0 2.4 3.2 2.4 3.2 4.8a1.6 1.6 0 01-1.6 1.6H16M23 17h4M27 20v-6a2 2 0 00-4 0v6"
        strokeWidth="2"
      />
    </g>
  </svg>
);
